// extracted by mini-css-extract-plugin
export default {"title-and-number":"title-and-number_title-and-number__76Erm","number":"title-and-number_number__078XD","none":"title-and-number_none__fh-tR","text":"title-and-number_text__h1QR9"};